export const cbtContentTableColumns = [
  {
    id: "S.No",
    label: "S.No",
    minWidth: 70,
    align: "left",
  },
  {
    id: "title",
    label: "Title",
    minWidth: 200,
    align: "left",
  },
  {
    id: "description",
    label: "Description",
    minWidth: 300,
    align: "left",
    type: "text",
  },
  {
    id: "attachedFile",
    label: "Attached File",
    minWidth: 160,
    align: "center",
  },
  {
    id: "thumbnail",
    label: "Thumbnail",
    minWidth: 120,
    align: "center",
    type: "thumbnail",
  },
  {
    id: "readTime",
    label: "Read Time (min)",
    minWidth: 100,
    align: "center",
    type: "text",
  },
  {
    id: "status",
    label: "Status",
    minWidth: 100,
    align: "center",
    type: "status",
  },
  {
    id: "createdBy.fullname",
    label: "Created By",
    minWidth: 150,
    align: "center",
    type: "text",
  },
  {
    id: "createdAt",
    label: "Created Date",
    minWidth: 120,
    align: "center",
    type: "date",
  },
  {
    id: "updatedAt",
    label: "Updated Date",
    minWidth: 120,
    align: "center",
    type: "date",
  },
  {
    id: "action",
    label: "Action",
    minWidth: 140,
    align: "center",
  },
];

export const cbtContentFormFields = [
  {
    name: "title",
    label: "Title",
    type: "text",
    required: true,
    maxLength: 200,
    placeholder: "Enter CBT content title",
  },
  {
    name: "description",
    label: "Description",
    type: "textarea",
    required: true,
    maxLength: 1000,
    placeholder: "Enter CBT content description",
    rows: 4,
  },
  {
    name: "attachedFile",
    label: "Attached File",
    type: "file",
    required: false,
    accept: "*/*",
    helperText: "Upload any file (PDF, video, image, etc.)",
  },
  {
    name: "thumbnail",
    label: "Thumbnail",
    type: "file",
    required: false,
    accept: "image/*",
    helperText: "Upload thumbnail image (PNG, JPG, JPEG)",
  },
  {
    name: "readTime",
    label: "Read Time (minutes)",
    type: "number",
    required: false,
    min: 0,
    placeholder: "e.g., 5",
  },
  // Status is controlled via table toggle, not in modal
];
